import { render, staticRenderFns } from "./ChannelManagerRegion.vue?vue&type=template&id=43c954fd&"
import script from "./ChannelManagerRegion.vue?vue&type=script&lang=js&"
export * from "./ChannelManagerRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c954fd')) {
      api.createRecord('43c954fd', component.options)
    } else {
      api.reload('43c954fd', component.options)
    }
    module.hot.accept("./ChannelManagerRegion.vue?vue&type=template&id=43c954fd&", function () {
      api.rerender('43c954fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ChannelManagerRegion.vue"
export default component.exports